export default function BeliefCard({ icon, text }) {
  return (
    <div
      className="
        h-full
        min-h-[320px]
        bg-white/70
        backdrop-blur-sm
        rounded-[28px]
        p-8
        text-center
        border
        border-[#E5DDD2]
        hover:-translate-y-4
        hover:scale-105
        transition-all
        duration-300
        shadow-sm
        hover:shadow-xl
        flex
        flex-col
      "
    >
      <div
        className="
          w-20
          h-20
          mx-auto
          mb-6
          rounded-full
          bg-[#E7DDD1]
          flex
          items-center
          justify-center
          text-3xl
          shrink-0
        "
      >
        {icon}
      </div>

      <p className="text-[#2C2C2C] leading-relaxed flex-grow">
        {text}
      </p>
    </div>
  );
}